import { LoadableLazy } from '@confluence/loadable';

export const Nav4CollapseReminderSpotlightLoader = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-Nav4ChangeboardingSpotlight" */ '../src/Nav4CollapseReminderSpotlight.tsx'
			)
		).Nav4CollapseReminderSpotlight,
});

export { useHasDismissedNav4CollapseReminderSpotlight } from '../src/useHasDismissedNav4CollapseReminderSpotlight.ts';
